const AVATAR_PALETTE = ['2173FF', 'D32F2F', 'ED6C02', '00A07E', 'FF9900', 'A0DA1D'];

export const hashString = (value) => {
  const s = String(value ?? '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

export const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

export const getAvatarSrc = (name, id) => {
  const bg = AVATAR_PALETTE[hashString(id) % AVATAR_PALETTE.length];
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || '?')}&background=${bg}&color=fff&size=48`;
};
